import React from "react";
import { Link } from "react-router-dom";
import { useAppContext } from '../Contexts/AppContext';
import ProductActions from "../Components/ProductActions";
import ProductImage from "./ProductImage";


const SideCart = () => {
    const { cart } = useAppContext();

    return (
        <>
        <div className="mini-cart" id="mini-cart">

            <button className="close" aria-label="Close" onClick={toggleMiniCart} />

            {cart && cart.length > 0 &&
            <div className="cart-top">
                <div className="d-flex justify-content-between align-items-center">
                    <span className="title">סל הקניות שלי</span>
                    <br />
                    <div className="carttotal">
                        סה"כ סל:&nbsp;&nbsp;<span>{cart.reduce((a, v) => a + v.itemTotal, 0).toFixed(2)}</span> ₪
                        <br />
                        <span>{cart.length}</span>
                        <span> מוצרים בסל</span>
                    </div>
                </div>
            </div>
            }

            <div className="sidecart" >
                {cart && cart.length === 0
                    ? <div className="d-flex justify-content-center align-items-center h-100">
                        <h5 className="fw-bold">סל הקניות ריק</h5>
                      </div>
                    : <>
                        <div id="items">
                            <ul id="carttable">
                                {cart.map((item, idx) => (
                                    <CartItem item={item} key={idx} />
                                ))}
                            </ul>
                        </div>
                        <div className="d-flex justify-content-between align-items-center pt-2" >
                            <Link className="btn btn-success" to={'Cart'} onClick={toggleMiniCart}>עריכת סל הקניות</Link>
                            <Link className="btn btn-success" to={'checkout'} onClick={toggleMiniCart}>מעבר לתשלום</Link>
                        </div>
                        <br />
                      </>
                }
            </div>

        </div>

        <div className="overlay body_overlay" onClick={toggleMiniCart}></div>
        </>
    )
}

const CartItem = ({item}) => { // ← No need for rawItem anymore
    // No useEffect needed - item is already enriched in context!
    
    if (!item || !item.product || !item.product.units || !item.product.units.length || !item.unit) {
        return <li>Loading...</li>;
    }

    return (
        <li id={item.id} className="item" key={item.id}>
            <div className="item">
                <div className="thumb">
                    <ProductImage product={item.product} />
                </div>
                <div className="content">
                    <div>{item.product.productName}</div>
                    <span className="qtty">{item.itemQtty} {item.unit?.unitName || 'יח׳'}</span>
                </div>
                <span className="total">{item.itemTotal.toFixed(2)}</span>
                <span className="notes">{item.itemNotes}</span>
                {/* <button className="remove" onClick={() => handleRemove(item.id)} /> */}
            </div>

            <ProductActions 
                product={item.product}
                showNotes={false}
                className="product-page cart-item"
            />
        </li>
    )
}

export function toggleMiniCart() {
    const miniCart = document.getElementById('mini-cart');
    const body = document.body;
    
    if (miniCart.classList.contains("open-cart")) {
        miniCart.classList.remove("open-cart");
        body.classList.remove("open-cart");
    }
    else {
        miniCart.classList.add("open-cart");
        body.classList.add("open-cart");
    }
}


export default SideCart;
